import { Box, Heading, Text, Button, ChakraProvider } from "@chakra-ui/react";

export default function NotFound({ error, resetErrorBoundary }) {
  // const backHome = () => {
  //   history.push("/home");
  // };
  return (
    <ChakraProvider>
      <Box textAlign="center" py={10} px={6}>
        <Heading
          display="inline-block"
          as="h2"
          size="2xl"
          bgGradient="linear(to-r, yellow.400, yellow.600)"
          backgroundClip="text"
        >
          500
        </Heading>
        <Text fontSize="18px" mt={3} mb={2}>
          {error.message}
        </Text>
        <Text color={"gray.500"} mb={6}>
          This was unexpected
        </Text>

        <Button
          colorScheme="yellow"
          bgGradient="linear(to-r, yellow.400, yellow.500, yellow.600)"
          color="black"
          variant="solid"
          onClick={resetErrorBoundary}
        >
          Go to Home
        </Button>
      </Box>
    </ChakraProvider>
  );
}
